import {Store, StoreOptions} from 'vuex';
import VuexLogger from 'vuex/dist/logger';
import {AlertNotificationModule, ClubModule, ProfileModule, UrlModule} from './modules';
import LtFramework from 'types/lt/ltFramework';

const vuexLogger = VuexLogger<LtFramework.IRootState>({
	collapsed: false,
});

export const storeOptions: StoreOptions<LtFramework.IRootState> = {
    state: {
        version: '1.0.0',
	},
	strict: process.env.NODE_ENV === 'development',
    modules: {
		alertNotificationModule: AlertNotificationModule,
		clubModule: ClubModule,
		profileModule: ProfileModule,
		urlModule: UrlModule,
    },
	plugins: process.env.NODE_ENV === 'development' ? [vuexLogger] : [],
};

const store = new Store<LtFramework.IRootState>(storeOptions);

export default store;
